import { useAtomValue } from "jotai";
import { baseUrl } from "../utils/globals";
import { useSwrData } from "./swrWrapper";
import { userInfoAtom } from "../atoms/utilsAtoms";

export const useFetchAllApprovalRequests = (filters = { role: '', status: '', search: '', sort: '' }) => {
  const user = useAtomValue(userInfoAtom);
  const url = `${baseUrl}/admin/trc?status=${filters.status || ''}&role=${filters.role || ''}&search=${filters.search || ''}&sort=${filters.sort || ''}`;
  const data = useSwrData(url, user.token, null);
  return data;
}

export const useFetchAllContents = (filters = { type: '', search: '' }, fromAdmin=false) => {
  const user = useAtomValue(userInfoAtom);
  const url = `${baseUrl}/trc/content?type=${filters.type}&search=${filters.search}&fromAdmin=${fromAdmin}`;
  const data = useSwrData(url, user.token, null);
  return data;
}

export const useFetchTrcContentById = (id) => {
  const user = useAtomValue(userInfoAtom);
  const url = `${baseUrl}/trc/content/${id}`;
  const data = useSwrData(url, user.token, null);
  return data;
}

export const useFetchAllTypesOfContents = () => {
  const user = useAtomValue(userInfoAtom);
  const url = `${baseUrl}/trc/all-contents`;
  const data = useSwrData(url, user.token, null);
  return data;
}